import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const BreadcrumbTitle = props => {
  const { title, breadcrumbItems, state } = props
  let itemLength = 0
  if (breadcrumbItems) {
    itemLength = breadcrumbItems.length
  }

  const renderBreadcrumbItem = (item, isFirst, isLast) => {
    if (isFirst && item?.title === "Dashboard") {
      return <Link to="/">{item.title}</Link>
    } else if (isLast) {
      return item?.title
    }
    if (item?.type === "tab") {
      return (
        <span onClick={item?.clickHandler} style={{ cursor: "pointer" }}>
          {item.title}
        </span>
      )
    }
    return (
      <Link to={item?.link} state={state ? state : {}}>
        {item.title}
      </Link>
    )
  }

  return (
    <React.Fragment>
      <Row className="d-none d-lg-block">
        <Col xs="12">
          <div className="page-title-box d-flex align-items-center justify-content-between">
            <h5 className="mb-0 font-size-18">
              <b>{title}</b>
            </h5>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                {breadcrumbItems &&
                  breadcrumbItems.map((item, key) => (
                    <BreadcrumbItem key={key} active={key + 1 === itemLength}>
                      {renderBreadcrumbItem(
                        item,
                        key === 0,
                        key + 1 === itemLength
                      )}
                    </BreadcrumbItem>
                  ))}
              </ol>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="d-block d-lg-none">
        <Col>
          <div className="page-title-box d-flex align-items-center ">
            <ol className="breadcrumb m-0">
              {breadcrumbItems &&
                breadcrumbItems.map((item, key) => (
                  <BreadcrumbItem key={key} active={key + 1 === itemLength}>
                    {renderBreadcrumbItem(
                      item,
                      key === 0,
                      key + 1 === itemLength
                    )}
                  </BreadcrumbItem>
                ))}
            </ol>
          </div>
        </Col>
      </Row>
      <Row className="d-block d-lg-none">
        <Col>
          <div className="page-title-box d-flex align-items-center">
            <h4 className="mb-0 font-size-18">{title}</h4>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

BreadcrumbTitle.propTypes = {
  breadcrumbItems: PropTypes.array,
  // title: PropTypes.string,
}

export default BreadcrumbTitle
